import template from './employeeName.html';
import controller from './employeeName.controller';
import './employeeName.scss';

let employeeNameComponent = {
  restrict: 'E',
  bindings: {
    name : '@',
    enrollment: '@'
  },
  template,
  controller
};

export default employeeNameComponent;



// WEBPACK FOOTER //
// ./client/app/components/employeeName/employeeName.component.js